import { useOrderStepsNavigator } from '../../hooks/useOrderStepsNavigator'
import { Bulk } from './Bulk'
import { Single } from './Single'

import { Box } from '@mui/material'

const growStyle = { height: 42 }

export function Stats() {
  const { currentOrders } = useOrderStepsNavigator()
  if (currentOrders.length === 0) return null

  return (
    <Box
      width="100%"
      flex="0 1 auto"
      sx={growStyle}
      data-trackid="navigo-order-overview-stats"
      data-testid="navigo-order-overview-stats"
    >
      {currentOrders.length > 1 ? (
        <Bulk extOrders={currentOrders} />
      ) : (
        <Single extOrder={currentOrders[0]} />
      )}
    </Box>
  )
}
